import { StopPriceInput } from 'components/PlaceOrderStopPriceInput'
import { memo, useCallback, useEffect } from 'react'
import { useAppDispatch } from 'store'
import { useOrderStopPrice } from 'store/order/hooks'
import { setStopPrice } from 'store/order/reducer'
import { Space16, Space8 } from 'styles'
import { Ether } from 'types'
import { toFixed } from '../../utils/number'

export const StopPriceInputController = memo<{ quoteScale: number }>(
  ({ quoteScale }) => {
    const dispatch = useAppDispatch()
    const stopPrice = useOrderStopPrice()
    const onChangePrice = useCallback(
      (price: Ether) => {
        dispatch(setStopPrice(toFixed(price, quoteScale)))
      },
      [quoteScale],
    )

    useEffect(() => {
      // Clear stop price when unmount
      return () => {
        dispatch(setStopPrice(''))
      }
    }, [])

    return (
      <>
        <Space8 />
        <StopPriceInput
          currentPrice={stopPrice}
          onChangePrice={onChangePrice}
        />
      </>
    )
  },
)
